import { http } from "../../utils/config";

/**
 * Yêu cầu hỗ trợ (ticket) — cư dân đề nghị sửa thông tin sai trong hồ sơ.
 *
 * Backend dùng chung bảng `reflections` nhưng endpoint tách hẳn: hai loại vé
 * đếm riêng, báo cáo riêng và xử lý ở hai màn khác nhau.
 */
const ticketAPI = {
  getTickets: (params = {}) => {
    return http.get("/api/v1/admin/tickets", { params });
  },

  getTicketById: (id) => {
    return http.get(`/api/v1/admin/tickets/${id}`);
  },

  /** Chuyển trạng thái: processing | completed | rejected (rejected bắt buộc có lý do). */
  replyTicket: (id, data) => {
    return http.put(`/api/v1/admin/tickets/${id}/reply`, data);
  },

  deleteTicket: (id) => {
    return http.delete(`/api/v1/admin/tickets/${id}`);
  },

  /** Danh mục nội dung + nhãn ô nhập — lấy từ backend, không chép cứng. */
  getMeta: () => {
    return http.get("/api/v1/admin/tickets/meta");
  },

  /** Số vé theo trạng thái + số vé trưởng khu phố gửi, cho mini dashboard. */
  getStats: () => {
    return http.get("/api/v1/admin/tickets/stats");
  },
};

export const ticketHelpers = {
  extractTicketData: (response) => {
    if (response.data && response.data.success) {
      return response.data.data;
    }
    throw new Error(response.data?.message || "Unknown error occurred");
  },

  extractTicketList: (response) => {
    if (response.data && response.data.success) {
      const data = response.data.data;
      return {
        tickets: data.data || [],
        pagination: {
          current: data.current_page,
          pageSize: data.per_page,
          total: data.total,
          from: data.from,
          to: data.to,
          lastPage: data.last_page,
        },
      };
    }
    throw new Error(response.data?.message || "Unknown error occurred");
  },
};

export const withErrorHandling = (apiFunction) => {
  return async (...args) => {
    try {
      const response = await apiFunction(...args);
      return response;
    } catch (error) {
      console.error("API Error:", error);
      if (error.response) {
        const { status, data } = error.response;
        switch (status) {
          case 400: throw new Error(data.message || "Dữ liệu không hợp lệ");
          case 401: throw new Error("Bạn cần đăng nhập để thực hiện thao tác này");
          case 403: throw new Error("Bạn không có quyền thực hiện thao tác này");
          case 404: throw new Error("Không tìm thấy dữ liệu yêu cầu");
          case 422: throw new Error(data.message || "Dữ liệu không hợp lệ");
          case 500: throw new Error(data.message || "Lỗi server, vui lòng thử lại sau");
          default: throw new Error(data.message || "Đã có lỗi xảy ra");
        }
      } else if (error.request) {
        throw new Error("Không thể kết nối đến server");
      } else {
        throw new Error(error.message || "Đã có lỗi xảy ra");
      }
    }
  };
};

export const ticketAPIWithErrorHandling = {
  getTickets: withErrorHandling(ticketAPI.getTickets),
  getTicketById: withErrorHandling(ticketAPI.getTicketById),
  replyTicket: withErrorHandling(ticketAPI.replyTicket),
  deleteTicket: withErrorHandling(ticketAPI.deleteTicket),
  getMeta: withErrorHandling(ticketAPI.getMeta),
  getStats: withErrorHandling(ticketAPI.getStats),
};

export default ticketAPI;
